import { render, staticRenderFns } from "./AreaPc.vue?vue&type=template&id=0464476f&scoped=true&"
import script from "./AreaPc.vue?vue&type=script&lang=js&"
export * from "./AreaPc.vue?vue&type=script&lang=js&"
import style0 from "./AreaPc.vue?vue&type=style&index=0&id=0464476f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0464476f",
  null
  
)

export default component.exports